<script>
	export default {
		name: 'AdminExecuter',
		methods: {
			adminGetCriterium(criteriumCode, param) {
				const self_ = this;

				const criteria_ = self_.getAdminState('criteria')

				if(self_.isFalse(criteriumCode)) { return null }

				return criteria_[criteriumCode][param]
			},
			adminGetGroup(groupCode, param) {
				const self_ = this;

				const groups_ = self_.getAdminState('groups')

				if(self_.isFalse(groupCode)) { return null }

				return groups_[groupCode][param]
			},
			adminGetUser(username, param) {
				const self_ = this;

				const users_ = self_.getAdminState('users')

				if(self_.isFalse(username)) { return null }

				let uid_ = null;
				let user_ = {}
				Object.keys(users_).forEach(key => {
					if(users_[key].username == username) {
						uid_ = key;
						user_ = users_[key]
					}
				})

				if(param == 'uid') { return uid_ }
				else { return user_[param] }
			},
			adminGetVoucher(voucherCode, param) {
				const self_ = this;

				const vouchers_ = self_.getAdminState('vouchers')

				if(self_.isFalse(voucherCode)) { return null }

				return vouchers_[voucherCode][param]
			},
			adminGetTraining(courseCode, moduleCode, sectionCode, param) {
				const self_ = this;

				const trainings_ = self_.getAdminState('trainings')

				if(self_.isFalse(courseCode)) { return null }

				// course
				if(self_.isFalse(moduleCode) && self_.isFalse(sectionCode)) {
					return trainings_[courseCode][param]
				}
				// module
				else if(self_.isFalse(sectionCode)) {
					return trainings_[courseCode].modules[moduleCode][param]
				}
				// section
				else {
					return trainings_[courseCode].modules[moduleCode].sections[sectionCode][param]
				}
			},
			adminSetData(dataType) {
				const self_ = this;

				const data_ = self_.getAdminState('data')

				let promiseSequence_ = Promise.resolve()

				return new Promise((resolve, reject) => {
					Object.keys(data_).forEach(key => {
						// for user
						if(dataType == 'registerUser') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_registerUser(data_[key]) }) }
						if(dataType == 'resetPassword') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_resetPassword(data_[key]) }) }
						if(dataType == 'updateUser') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_updateUser(data_[key]) }) }
						if(dataType == 'changeUserGroup') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_changeUserGroup(data_[key]) }) }
						if(dataType == 'changeUserOption') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_changeUserOption(data_[key]) }) }
						if(dataType == 'changeSecurityGroup') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_changeSecurityGroup(data_[key]) }) }
						if(dataType == 'changeUserStatus') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_changeUserStatus(data_[key]) }) }
						if(dataType == 'deleteUser') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_deleteUser(data_[key]) }) }
						// for group
						if(dataType == 'createGroup') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setGroup(data_[key]) }) }
						if(dataType == 'updateGroup') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setGroup(data_[key]) }) }
						if(dataType == 'deleteGroup') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_deleteGroup(data_[key]) }) }
						// for point
						if(dataType == 'givePoint') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_givePoint(data_[key]) }) }
						if(dataType == 'cancelPoint') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_cancelPoint(data_[key]) }) }
						if(dataType == 'createCriterium') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setCriterium(data_[key]) }) }
						if(dataType == 'updateCriterium') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setCriterium(data_[key]) }) }
						if(dataType == 'deleteCriterium') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_deleteCriterium(data_[key]) }) }
						if(dataType == 'createVoucher') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setVoucher(data_[key]) }) }
						if(dataType == 'updateVoucher') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_setVoucher(data_[key]) }) }
						if(dataType == 'deleteVoucher') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_deleteVoucher(data_[key]) }) }
						// for training
						if(dataType == 'openTrainingCourse') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_openTrainingCourse(data_[key]) }) }
						if(dataType == 'openTrainingModule') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_openTrainingModule(data_[key]) }) }
						if(dataType == 'openTrainingSection') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_openTrainingSection(data_[key]) }) }
						if(dataType == 'closeTrainingCourse') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_closeTrainingCourse(data_[key]) }) }
						if(dataType == 'closeTrainingModule') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_closeTrainingModule(data_[key]) }) }
						if(dataType == 'closeTrainingSection') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_closeTrainingSection(data_[key]) }) }
						// for notification
						if(dataType == 'sendEmailNotification') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_sendEmailNotification(data_[key]) }) }
						if(dataType == 'sendSmsNotification') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_sendSmsNotification(data_[key]) }) }
						if(dataType == 'sendPushNotification') { promiseSequence_ = promiseSequence_.then(() => { return self_.$_adminExec_sendPushNotification(data_[key]) }) }
					})
					promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
				})
			},
			$_adminExec_registerUser(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						if(data.accountType == 'username') {
							return self_.registerUserByUsername(data.username, data.password, data.fullName, data.email, data.phone, data.skipNewSystem, data.skipOldSystem)
						} else if(data.accountType == 'email') {
							return self_.registerUserByEmail(data.username, data.password, data.fullName, data.phone, data.skipNewSystem, data.skipOldSystem)
						} else if(data.accountType == 'phone') {
							return self_.registerUserByPhone(data.username, data.password, data.fullName, data.email, data.skipNewSystem, data.skipOldSystem)
						}
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_resetPassword(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.resetPassword(data.uid, data.password)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_updateUser(data) {
				const self_ = this;

				let body_ = {}
				if(!self_.isFalse(data.fullName)) { body_.fullName = data.fullName }
				if(!self_.isFalse(data.email)) { body_.email = data.email }
				if(!self_.isFalse(data.phone)) { body_.phone = data.phone }

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.updateUser(data.uid, body_)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_changeUserGroup(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						if(data.allocated) {
							return self_.allocateUserToGroup(data.uid, data.userGroupCode, data.userGroupName)
						} else {
							return self_.deallocateUserFromGroup(data.uid, data.userGroupCode)
						}
					}).then(() => {
						if(data.setAsMain) {
							const body_ = {
								userGroupCode: data.userGroupCode,
								userGroupName: data.userGroupName
							}
							return self_.updateUser(data.uid, body_)
						} else {
							return Promise.resolve()
						}
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_changeUserOption(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.updateUserOptions(data.uid, data.resetPassword, data.resetSecurityQuestion)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_changeSecurityGroup(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						const body_ = {
							securityGroupCode: data.securityGroupCode,
							securityGroupName: data.securityGroupName
						}
						return self_.updateUser(data.uid, body_)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_changeUserStatus(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						if(data.disabled) {
							return self_.disableUser(data.uid)
						} else {
							return self_.enableUser(data.uid)
						}
					}).then(() => {
						const body_ = {
							blocked: data.blocked,
							disabled: data.disabled
						}
						return self_.updateUser(data.uid, body_)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_deleteUser(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.deleteUser(data.uid)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_setGroup(data) {
				const self_ = this;

				const description_ = data.description || null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.setUserGroup(data.code, data.name, description_)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_deleteGroup(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.deleteUserGroup(data.code)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_givePoint(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						//
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_cancelPoint(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						//
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_setCriterium(data) {
				const self_ = this;

				const description_ = data.description || null;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.setCriterium(data.code, data.name, description_)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_deleteCriterium(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.deleteCriterium(data.code)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_setVoucher(data) {
				const self_ = this;

				const startDate_ = new Date(data.startDate)
				const endDate_ = new Date(data.endDate)

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.setVoucher(data.code, data.name, data.point, startDate_, endDate_, data.criteriumCode, data.criteriumName, data.status)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_deleteVoucher(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.deleteVoucher(data.code)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_openTrainingCourse(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.openTrainingCourse(data.uid, data.trainingCourseCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_openTrainingModule(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.openTrainingModule(data.uid, data.trainingCourseCode, data.trainingModuleCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_openTrainingSection(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.openTrainingSection(data.uid, data.trainingCourseCode, data.trainingModuleCode, data.trainingSectionCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_closeTrainingCourse(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.closeTrainingCourse(data.uid, data.trainingCourseCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_closeTrainingModule(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.closeTrainingModule(data.uid, data.trainingCourseCode, data.trainingModuleCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_closeTrainingSection(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.initializeTrainings(data.trainingCourseCode)
					}).then(() => {
						return self_.closeTrainingSection(data.uid, data.trainingCourseCode, data.trainingModuleCode, data.trainingSectionCode)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_sendEmailNotification(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.sendGridPost(data.email, data.from, data.cc, data.bcc, data.subject, data.html)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_sendSmsNotification() {
				const self_ = this;

				return Promise.resolve()
			},
			$_adminExec_sendPushNotification(data) {
				const self_ = this;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.oneSignalPushNotificationByUid(data.uid, data.title, data.text, data.url)
					}).then(result => {
						self_.$_adminExec_pushResult(result)
						resolve()
					}).catch(error => {
						self_.$_adminExec_pushError(error)
						resolve()
					})
				})
			},
			$_adminExec_pushResult(result) {
				const self_ = this;

				let result_ = self_.getAdminState('result')
				result_.push(result)
				self_.setAdminState('result', result_)
			},
			$_adminExec_pushError(error) {
				const self_ = this;

				let error_ = self_.getAdminState('error')
				error_.push(error)
				self_.setAdminState('error', error_)
			}
		}
	}
</script>